<button class="btn btn-primary mb-1" [disabled]="!isEnabled || isBlocked" (click)="openCancelledTicketsModal()" #button>
    <span class="element-text">{{ 'cancelled' | translate }}</span>
</button>